import * as DividerPanelStyles from "./divider-panel.module.css"

import React from "react"

const DividerPanel = () => {
    return <div className={DividerPanelStyles.block} />
}

export default DividerPanel
